export const Types = {
  SEARCH_CPF: "consignadoInss/SEARCH_CPF",
  SEARCH_CPF_SUCCESS: "consignadoInss/SEARCH_CPF_SUCCESS",
  SEARCH_NB: "consignadoInss/SEARCH_NB",
  SEARCH_NB_SUCCESS: "consignadoInss/SEARCH_NB_SUCCESS",
  UNSET_REDIRECT: "consignadoInss/UNSET_REDIRECT",
  CLOSE_NBS: "consignadoInss/CLOSE_NBS"
};

const INITIAL_STATE = {
  cpf: "",
  loadingINSS: false,
  dataCPF: null,
  NB: "",
  dataNB: [],
  redirect: false
};

export default function consignadoInss(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.SEARCH_CPF:
      return {
        ...state,
        loadingINSS: true,
        cpf: action.payload.cpf,
        dataCPF: null
      };
    case Types.SEARCH_CPF_SUCCESS:
      return {
        ...state,
        loadingINSS: false,
        dataCPF: action.payload.data
      };
    case Types.SEARCH_NB:
      return {
        ...state,
        loadingINSS: true,
        NB: action.payload.NB
      };
    case Types.SEARCH_NB_SUCCESS:
      if (
        state.dataNB.find(nb => nb.beneficio === action.payload.data.beneficio)
      ) {
        return {
          ...state,
          loadingINSS: false,
          redirect: true
        };
      } else {
        return {
          ...state,
          loadingINSS: false,
          dataNB: [...state.dataNB, action.payload.data],
          redirect: true
        };
      }
    case Types.UNSET_REDIRECT:
      return {
        ...state,
        redirect: false
      };
    case Types.CLOSE_NBS:
      return {
        ...state,
        dataNB: action.payload.nbs
      };
    default:
      return state;
  }
}

export const Creators = {
  searchCPF: cpf => ({
    type: Types.SEARCH_CPF,
    payload: { cpf }
  }),
  searchCPFSuccess: data => ({
    type: Types.SEARCH_CPF_SUCCESS,
    payload: { data }
  }),
  searchNB: NB => ({
    type: Types.SEARCH_NB,
    payload: { NB }
  }),
  searchNBSuccess: data => ({
    type: Types.SEARCH_NB_SUCCESS,
    payload: { data }
  }),
  unsetRedirect: () => ({
    type: Types.UNSET_REDIRECT
  }),
  closeNBS: nbs => ({
    type: Types.CLOSE_NBS,
    payload: { nbs }
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/consignadoInss.js